export default "__VITE_ASSET__pOwV0NOJ__"